'use strict';

const _ = require('lodash');

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec'
];

/** @DataCaptureSelectorController */
const DataCaptureSelectorController = function ($scope, Utils, Flux, DataCaptureSelectorActions, $timeout, $rootScope) {

  const DataCaptureSelectorStore = Flux.Store.get('DataCaptureSelectorStore');
  const DataCaptureStore = Flux.Store.get('DataCaptureStore');
  const TopControlsStore = Flux.Store.get('TopControlsStore');

  /* eslint consistent-this: ["error", "vm"] */
  const vm = this;

  vm.availableDataCaptures = [];
  vm.noDataCaptures = true;
  vm.refreshTimestamp = 0;

  vm.date = null;
  vm.currentDatacapture = null;
  vm.displayDate = 'Loading...';
  vm.visibleDatacaptures = [];

  vm.loading = false;

  // Toggle view switch between calendar view and datacaptures view
  const TOGGLE_SHOW_CALENDAR = true;
  const TOGGLE_SHOW_DATACAPTURES = false;
  vm.toggleView = TOGGLE_SHOW_CALENDAR; // Default show calendar

  /**
   * Toggle picker to show calendar picker view
   */
  vm.showCalendarPicker = () => {

    vm.toggleView = TOGGLE_SHOW_CALENDAR;
  };

  /**
   * Toggle picker to show datacaptures picker view
   */
  vm.showDatacapturesPicker = () => {

    vm.toggleView = TOGGLE_SHOW_DATACAPTURES;
  };

  /**
   * Used by the directive in order to switch datacaptures
   */
  vm.nextDataCapture = () => {

    DataCaptureSelectorActions.NextDatacapture.dispatch();
  };

  /**
   * Used by the directive in order to switch datacaptures
   */
  vm.prevDataCapture = () => {

    DataCaptureSelectorActions.PreviousDatacapture.dispatch();
  };

  vm._handleYearSelected = (year, activeDate) => {

    const haveDatacaptures = vm.availableDataCaptures.some((datacapture) => {

      return datacapture._localTimezoneCapturedAt.getUTCFullYear() === year;
    });

    if (!haveDatacaptures) { // Don't move, the year does not have datacaptures
      return activeDate;
    }
    const date = new Date(activeDate);
    date.setYear(year);
    return date;
  };

  // Booster helpers ///////////////////////////////////////////////////////////

  /**
   * Defines how many datacaptures were taken in that date, now defaults to 0,
   * multidacapture will come later in further core versions
   */
  /* eslint-disable no-unused-vars */
  vm.dateEvents = (eachDayInTheMonth) => {

    return 0;
  };

  /**
  * CSS classes to be added to the current evaluation date
  */
  vm.dateFlags = (eachDayInTheMonth) => {

    const classes = [''];
    const currentDay = new Date(eachDayInTheMonth);

    // Datacaptures per day
    vm.availableDataCaptures.forEach((dataCap) => {

      if (dataCap.capturedAt) {
        const capturedAt = dataCap._localTimezoneCapturedAt || DataCaptureSelectorStore.getLocalTimezoneDate(dataCap.capturedAt);
        if (DataCaptureSelectorStore.isSameDate(currentDay, capturedAt)) {
          dataCap.dataCaptureLayers.forEach((dataCaptureLayer) => {

            classes.push(dataCaptureLayer.layerType);
          });
        }
      }

    });

    return classes;
  };
  /* eslint-enable no-unused-vars */

  /**
   * Disable a date if no datacaptures are present in it
   *
   * @param {Object} eachDayInTheMonth Date object in browser timezone
   */
  vm.dateDisabled = (eachDayInTheMonth) => {

    let disabled = true;

    // Datacaptures per day
    vm.availableDataCaptures.forEach((dataCap) => {

      if (!disabled) { // already enabled end search, and not deleted
        return;
      }

      if (dataCap.capturedAt) {
        const capturedAt = dataCap._localTimezoneCapturedAt || DataCaptureSelectorStore.getLocalTimezoneDate(dataCap.capturedAt);
        if (DataCaptureSelectorStore.isSameDate(eachDayInTheMonth, capturedAt)) {
          disabled = false;
        }
      }

    });

    return disabled; // if no datacaps in that date, disable it
  };

  /**
   *
   * Return list of datacapture between `start` date and `end` date.
   * Used by the calendar to get visible datacaptures.
   *
   * @param {object} params
   * @params {date} params.start
   * @params {date} params.end
   * @return {array} - Array of datacaptures
   */
  vm.getDatacapturesByDate = ({ start, end }) => {

    const endTime = end.getTime();
    const startTime = start.getTime();
    const datacaptures = [];

    vm.availableDataCaptures.some((datacapture) => {

      const dcTime = datacapture._localTimezoneCapturedAt.getTime();

      if (dcTime > endTime) {
        return true;
      }

      if (dcTime > startTime) {
        datacaptures.push(datacapture);
      }

      return false;
    });
    return datacaptures;
  };

  /**
   * Disable positions out of datacaptures date range
   * @param {date} from - Current calendar position
   * @param {date} to - Destination position
   * @return {boolean} - Is valid position
   *
   * Positions after last datacapture are invalid
   * Positions before firstdatacapture are invalid
   */
  vm._isYearEnabled = (from, to) => {

    const first = vm.availableDataCaptures[0]._localTimezoneCapturedAt;
    const last = vm
      .availableDataCaptures[vm.availableDataCaptures.length - 1]
      ._localTimezoneCapturedAt;

    if (compare(from, to) > 0) { // go year back
      return first.getFullYear() <= to.getFullYear();
    }
    // go next year
    return last.getFullYear() >= to.getFullYear();

  };

  /**
   * Disable positions out of datacaptures date range
   * @param {date} from - Current calendar position
   * @param {date} to - Destination position
   * @return {boolean} - Is valid position
   *
   * Positions after last datacapture are invalid
   * Positions before firstdatacapture are invalid
   */
  vm._isMonthEnabled = (from, to) => {

    const first = new Date(vm.availableDataCaptures[0]._localTimezoneCapturedAt);
    const last = new Date(vm.availableDataCaptures[vm.availableDataCaptures.length - 1]._localTimezoneCapturedAt);
    const origin = new Date(from);
    const destination = new Date(to);

    origin.setUTCDate(1);
    destination.setUTCDate(1);

    if (compare(from, to) > 0) { // go month back
      first.setUTCDate(1);
      return compare(first, destination) <= 0;
    }
    // go month later
    last.setUTCDate(1);
    return compare(last, destination) >= 0;

  };

  // Handlers //////////////////////////////////////////////////////////////////

  /**
   * Handler for the date selected in the datepicker, this just emits the event
   * to the UI Store for this component (DacataptureSelectorStore)
   */
  vm._handleDateSelected = (ev, data) => {

    DataCaptureSelectorActions.DateChanged.dispatch({
      newDate : data
    });
  };

  vm._handleDatacaptureSelected = (ev, data) => {

    DataCaptureSelectorActions.DatacaptureSelected.dispatch({
      id: data.id
    });
    ev.stopPropagation();
  };

  vm._onDatacaptureSelected = (id) => {

    DataCaptureSelectorActions.DatacaptureSelected.dispatch({
      id
    });
  };

  vm._handleStoreLoaded = () => {

    vm.loading = false;
  };

  /**
   * Handler for the main DataCapture Store change, to get the available datacaps
   * an render them into the calendar.
   */
  vm._handleStoreChange =  _.debounce(() => {

    const currentDate = DataCaptureSelectorStore.get('currentDate');
    const currentDataCapture = DataCaptureStore.get('current');

    if (!currentDataCapture) {
      return;
    }

    vm.currentDatacapture = currentDataCapture;

    const tileLayerIndex = _.findIndex(currentDataCapture.dataCaptureLayers, (layer) => {

      return layer.layerType === 'tileLayer';
    });

    // initial load accounts for null state
    if (currentDataCapture && tileLayerIndex > -1) { // no spinner if theres no data captures
      if (new Date(vm.date).getTime() !== new Date(currentDate).getTime()) {
        $rootScope.$emit('MAP_LOADING');
        // TODO: determine if the spinner is needed here at all (should the calendar close or stay open when a date is selected?)
        // this.loading = true;
      }
    }

    vm.date = currentDate;

    // Get data from the store
    vm.availableDataCaptures = DataCaptureSelectorStore.get('availableDataCaptures');
    // Cache the local timezone of each data capture to avoid recalculation, and index them
    // for very fast date retrieval in the lookup methods
    vm.availableDataCaptures.forEach((dataCap) => {

      if (dataCap.capturedAt) {
        const localDate = getSiteDate(new Date(dataCap.capturedAt));
        dataCap._localTimezoneCapturedAt = localDate;
      }
    });

    vm.timezoneId = DataCaptureStore.get('timezoneId');

    vm.displayDate = DataCaptureSelectorStore.get('currentDisplayDate');

    // signal datepicker booster for refresh itself using timestamps to force a 'change' event
    vm.refreshDatePickerSignal = DataCaptureSelectorStore.getLocalTimezoneDate(Date.now());

    // evaluate active controls
    vm._togglePreviousNextControls();
  }, 0);

  /**
   * Check for earliest or newest dacaps selected and enable/disable prev/next controls
   */
  vm._togglePreviousNextControls = () => {

    let foundIndex;
    const current = DataCaptureStore.get('current');
    const available = DataCaptureSelectorStore.get('availableDataCaptures');
    const currentLayerType = TopControlsStore.get('currentLayerType');
    const availableByType = DataCaptureSelectorStore.get('availableDataCapturesByType')[currentLayerType];

    vm.noDataCaptures = !available || !available.length;
    vm.disablePreviousControl = false;
    vm.disableNextControl = false;

    if (current) {
      foundIndex = _.findIndex(available, 'id', current.id);
    }

    if (vm.noDataCaptures || !availableByType || foundIndex === 0) {
      vm.disablePreviousControl = true;
    }

    if (vm.noDataCaptures || !availableByType || foundIndex === available.length - 1) {
      vm.disableNextControl = true;
    }
  };

  /**
   * This function define how the datepicker should be rendered
   *
   * @param {object} params
   * @param {array<dates>} params.dates - Visible dates in datepicker
   * @param {number} params.month - Active month in datepicker
   * @param {date} params.activeDate - Active date in datepicker
   *
   * @return {object}
   * @return {object} .dates - Define how each day in the month shoudl be rendered
   * @return {object} .disableNextYear - Disable go to next year button
   * @return {object} .disablePrevYear - Disable go to previous year button
   * @return {object} .disableNextMonth - Disable go to next month button
   * @return {object} .disablePrevMonth - Disable go to previous month button
   */
  vm._refreshDatepicker = (params) => {

    const dates = params.days;
    const month = params.month;
    const activeDate = params.activeDate;

    // dates undefined or null
    if (!dates) {
      return [];
    }

    // dates array is empty
    if (dates.length === 0) {
      return [];
    }

    const firstDate = dates[0];
    const lastDate = dates[dates.length - 1];
    const selectedDate = vm.date;

    const datacaptures = vm.getDatacapturesByDate({
      start: firstDate,
      end: lastDate
    });

    const dateObjects = dates.map((date) => {

      const dcaptures = getDateDatacaptures(date, datacaptures);
      const flags = getFlagsFromDatacaptures(dcaptures);

      return {
        current: compare(date, new Date()) === 0,
        date,
        disabled: dcaptures.length === 0, // if no captures in date
        events:  dcaptures.length,
        flags,
        label: date.getDate(),
        selected: selectedDate && compare(date, selectedDate) === 0,
        today: compare(date, new Date()) === 0,
        secondary: date.getMonth() !== month
      };
    });

    const dcaptures = datacaptures.reduce((captures, capture) => {

      if (capture._localTimezoneCapturedAt.getUTCMonth() === month) {
        captures.push(capture);
      }
      return captures;
    }, []);

    vm.visibleDatacaptures = makeDatacapturesList(dcaptures);

    // enable navigation buttons in calendar
    let disableNextYear = true;
    let disablePrevYear = true;
    let disableNextMonth = true;
    let disablePrevMonth = true;

    if (activeDate && vm.availableDataCaptures && vm.availableDataCaptures.length > 1) {
      const nextYear = new Date(activeDate);
      const prevYear = new Date(activeDate);
      const prevMonth = new Date(activeDate);
      const nextMonth = new Date(activeDate);

      nextYear.setYear(activeDate.getFullYear() + 1);
      prevYear.setYear(activeDate.getFullYear() - 1);
      nextMonth.setMonth(month + 1);
      prevMonth.setMonth(month - 1);

      disableNextYear = !vm._isYearEnabled(activeDate, nextYear);
      disablePrevYear = !vm._isYearEnabled(activeDate, prevYear);
      disableNextMonth = !vm._isMonthEnabled(activeDate, nextMonth);
      disablePrevMonth = !vm._isMonthEnabled(activeDate, prevMonth);
    }

    return {
      dates: dateObjects,
      disableNextYear,
      disablePrevYear,
      disableNextMonth,
      disablePrevMonth
    };
  };

  /**
   * Construct a list to render datacaptures list view
   * @param {array<object>} datacaptures - Datacaptures to show in the list
   * @return {array<object>} - List with the necessary information to render datacaptures.
   */
  const makeDatacapturesList = (datacaptures) => {

    const captures = datacaptures.map((d) => {

      const datacapture = _.clone(d);
      const date = getSiteDate(new Date(datacapture.capturedAt));
      datacapture.title = `${MONTHS[date.getUTCMonth()]}, ${date.getUTCDate()}`;
      datacapture.time = formatTime(date);
      datacapture.layers = {
        mesh_gltf: false,
        pc_rgb: false,
        tileLayer: false
      };
      datacapture.selected = vm.currentDatacapture.id === datacapture.id;
      datacapture.dataCaptureLayers.forEach((layer) => {

        datacapture.layers[layer.layerType] = true;
      });

      return datacapture;
    });

    return captures.reverse();
  };

  const formatTime = (time) => {

    const hours = ('0' + time.getUTCHours()).slice(-2);
    const minutes = ('0' + time.getUTCMinutes()).slice(-2);
    return `${hours}:${minutes}`;
  };

  /**
    * Compare UTC dates
    *
    * @return {number}
    *
    * date1 > date2 returns > 0
    * date1 == date2 returns 0
    * date1 < date 2 returns < 0
    */
  const compare = (date1, date2) => {

    return (
      new Date(date1.getUTCFullYear(), date1.getUTCMonth(), date1.getUTCDate()) -
      new Date(date2.getUTCFullYear(), date2.getUTCMonth(), date2.getUTCDate())
    );
  };

  /**
   * Find datacaptures in date
   *
   * @param {date} date
   * @param {array} datacaptures
   * @return {array} - Array of datacaptures
   */
  const getDateDatacaptures = (date, datacaptures) => {

    const captures = [];
    datacaptures.some((datacapture) => {

      const x = compare(date, datacapture._localTimezoneCapturedAt);

      // if the datacapture is after the date finish bucle
      if (x < 0) {
        return true;
      }

      // If same date
      if (x === 0) {
        captures.push(datacapture);
      }

      return false;
    });

    return captures;
  };

  /**
   * @param {array} datacaptures
   * @return {string[]} - layers
   */
  const getFlagsFromDatacaptures = (datacaptures) => {

    const layers = new Set();
    datacaptures.forEach((datacapture) => {

      datacapture.dataCaptureLayers.forEach((layer) => {

        layers.add(layer.layerType);
      });
    });

    return Array.from(layers);
  };

  const getSiteDate = (date) => {

    const offset = DataCaptureStore.get('timezoneOffset');
    const ndate = new Date(date.getTime() + (offset * 60000));
    return ndate;
  };

  // watch booster component to catch a new date selected
  $scope.$on('dateSelected', vm._handleDateSelected.bind(vm));

  $scope.$on('datacaptureSelected', vm._handleDatacaptureSelected);

  //update UI on store change
  DataCaptureSelectorStore.on(DataCaptureSelectorStore.Events.Changed, vm._handleStoreChange.bind(vm), $scope);
  DataCaptureSelectorStore.on(DataCaptureSelectorStore.Events.Loaded, vm._handleStoreLoaded.bind(vm), $scope);
  TopControlsStore.on(TopControlsStore.Events.Changed, vm._handleStoreChange.bind(vm), $scope);
};

DataCaptureSelectorController.$inject = ['$scope', 'Utils', 'sbFlux', 'DataCaptureSelectorActions', '$timeout', '$rootScope'];
module.exports = DataCaptureSelectorController;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/DataCaptureSelectorController.js